import { render, staticRenderFns } from "./InfoStatistics.vue?vue&type=template&id=2932bcbf&scoped=true"
import script from "./InfoStatistics.vue?vue&type=script&lang=js"
export * from "./InfoStatistics.vue?vue&type=script&lang=js"
import style0 from "./InfoStatistics.vue?vue&type=style&index=0&id=2932bcbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932bcbf",
  null
  
)

export default component.exports